<template>
	<ui-chip
		:class="{ 'md-accent': isHovering }"
		:clickable="clickable"
		:disabled="disabled"
		:tooltip="tooltip"
		class="md-deletable"
		@click="!disabled && $emit('click', uri)"
		@mouseenter="isHovering = true"
		@mouseleave="isHovering = false"
	>
		<span class="ui-chip__record-icon fas fa-circle"></span>
		{{ name || uri }}
		<ui-button
			class="md-input-action"
			dense
			icon="fa fa-pencil"
			@click.stop="$emit('edit', uri)"
		/>
	</ui-chip>
</template>

<script>
import UiChip from "lib/components/ui/Chip";
import UiButton from "lib/components/ui/Button";

export default {
	name: "FavoriteChip",
	components: {
		UiChip,
		UiButton
	},
	mixins: [UiChip],
	props: {
		name: {
			type: String,
			default: null,
			required: false
		},
		uri: {
			type: String,
			default: null,
			required: true
		}
	},
	data() {
		return {
			isHovering: false
		};
	}
};
</script>

<style lang="scss" scoped>
.ui-chip {
	margin: 8px 4px 0 0;
	max-width: 224px; // will work down to iPhone5 (320px width)
	/deep/ .md-ripple {
		text-overflow: ellipsis; // cut and add ellipsis on overflowing text
		.ui-chip__record-icon {
			color: var(--ui-theme-text-on-secondary);
			visibility: hidden;
			width: 15px;
			height: 15px;
			opacity: 0;
			transition: visibility 0.15s linear, opacity 0.15s linear;
		}
		button {
			visibility: hidden;
			&.md-input-action {
				.md-icon {
					padding: 1px 0 0 1px;
					font-size: 12px !important;
					color: var(--ui-theme-text-on-secondary);
				}
			}
			opacity: 0;
		}
	}
	&:hover {
		background-color: var(--ui-theme-secondary) !important;
		color: var(--ui-theme-text-on-secondary) !important;
		/deep/ .md-ripple {
			.ui-chip__record-icon {
				visibility: visible;
				opacity: 1;
				width: 15px;
				height: 15px;
			}
			button {
				visibility: visible;
				opacity: 1;
				&.md-input-action {
					background-color: var(--ui-theme-secondary) !important;
				}
			}
		}
	}
}
</style>
